import { useQuery } from "@tanstack/react-query"
import { canonicalTopicActivityQuery } from "../lib/canonicalTopicActivityQuery"

export function useCanonicalTopicActivityQuery(
  ...args: Parameters<typeof canonicalTopicActivityQuery>
) {
  return useQuery(canonicalTopicActivityQuery(...args))
}
